import importer from 'common/importer';
const Config = importer('Config');
const { deloitReq: req } = importer('APIs', null);

let CORE_SCHEDULER_BASIC_AUTH;
if (Config.PLATFORM_TYPE != 'mobile') {
	CORE_SCHEDULER_BASIC_AUTH = WEB_SCHEDULER_BASIC_AUTH;
}

const main = (token) => {
	const data = {
		recoveryToken: token
	};
	const config = {
		headers: {
			Authorization: `Basic ${
				Config.SCHEDULER_BASIC_AUTH || CORE_SCHEDULER_BASIC_AUTH
			}`
		}
	};
	return req.post(`/auth/verify-recovery-token`, data, config);
};

export default main;
